export default __webpack_public_path__ + "static/media/chatBg.9c7c22e6.png";